import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.25 5.5a3.25 3.25 0 1 1 .799 2.134L9.577 10.95a3.25 3.25 0 0 1 .028 2.014l5.554 3.282a3.25 3.25 0 1 1-.764 1.291l-5.554-3.282a3.25 3.25 0 1 1-.064-4.574l5.573-3.377a3.3 3.3 0 0 1-.1-.804m3.25-1.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m-11 6.5a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m9.25 8.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }